import { BrushStroke, type BrushDab, type BrushPoint, type BrushSettings } from './brush';

export interface DrawingShape { kind: 'line' | 'rectangle' | 'ellipse'; style: 'spray' | 'marker' | 'pen' }
export const DEFAULT_SHAPE: DrawingShape = { kind: 'line', style: 'marker' };

/** Shapes supply a path to the existing brush; they never become another renderer. */
export function shapePath(kind: DrawingShape['kind'], start: BrushPoint, end: BrushPoint): BrushPoint[] {
  if (kind === 'line') return [start, end];
  if (kind === 'rectangle') return [start, { x: end.x, y: start.y }, end, { x: start.x, y: end.y }, start];
  const cx = (start.x + end.x) / 2, cy = (start.y + end.y) / 2;
  const rx = Math.abs(end.x - start.x) / 2, ry = Math.abs(end.y - start.y) / 2;
  const steps = Math.max(24, Math.ceil(Math.PI * 2 * Math.max(rx, ry) / 3));
  return Array.from({ length: steps + 1 }, (_, i) => ({ x: cx + rx * Math.cos(i / steps * Math.PI * 2), y: cy + ry * Math.sin(i / steps * Math.PI * 2) }));
}

export function shapeDabs(shape: DrawingShape, start: BrushPoint, end: BrushPoint, settings: BrushSettings, seed: number): { dabs: BrushDab[]; settings: BrushSettings } {
  const brush = { ...settings, kind: shape.style }, stroke = new BrushStroke(brush, seed);
  const [first, ...rest] = shapePath(shape.kind, start, end);
  const dabs = stroke.start(first);
  for (const point of rest) dabs.push(...stroke.move(point));
  dabs.push(...stroke.finish());
  return { dabs, settings: brush };
}
